module.exports = __webpack_public_path__ + "static/fontawesome-webfont-e6cf7c6ec7c2d6f670ae9d762604cb0b.woff2";